import { LISTING_BASE_PATH } from '../../common/constants/appConstant';
import { getHostName, getUrlParamsMapV2 } from '../../common/utils/browserUtils';
import { FILTER_TYPES } from '../constants/filterConstants';

export const validateTheme = ({ metaFilterList, themeValue }) => {
  let theme = '';
  metaFilterList?.forEach?.(filter => {
    if (filter?.urlParam === 'themes') {
      let splittedThemeValue = [];
      if (filter?.listingFilterValues?.length > 0) {
        if (themeValue?.includes('~')) {
          splittedThemeValue = themeValue.split('~');
        }
        filter?.listingFilterValues?.forEach?.(listingOption => {
          const filterCheck =
            splittedThemeValue?.length > 0
              ? splittedThemeValue.includes(listingOption?.uniqueId) ||
                splittedThemeValue.includes(listingOption?.uniqueId?.toLowerCase())
              : themeValue === listingOption?.uniqueId ||
                themeValue === listingOption?.uniqueId?.toLowerCase();
          if (filterCheck) {
            theme = themeValue;
          }
        });
      }
    }
  });
  return theme;
};

export const getAppliedFilterValue = urlParam => {
  const urlParams = getAllUrlParams();
  const currentValue = urlParams[urlParam] || urlParams[`${urlParam}`.toLowerCase()] || '';

  return currentValue?.split?.('~')?.filter(val => !!val) || [];
};

export const getReqDataSsr = requestParam => {
  if (requestParam) {
    const { body = {}, query = {} } = requestParam;
    // holidayType is not required in query params as there is extra filtering for it
    // on BE because of which it can lead to 0 packages in themes packages
    const { metadata: temp, holidayType, ...rest } = body;
    return {
      ...query,
      ...rest,
    };
  }
  return {};
};

export const getAllUrlParams = () => {
  // eslint-disable-next-line prefer-const
  let { metadata: temp, holidayType, ...urlParams } = getUrlParamsMapV2();
  // eslint-disable-next-line no-undef
  if (!ssr.isOnClient) {
    // eslint-disable-next-line no-undef
    const serverQueryParams = ssr.queryParams || {};
    urlParams = {
      ...serverQueryParams,
      ...urlParams,
    };
  } else {
    const { holidayType, ...ssrParams } = window.ssrRequestBody || {};
    urlParams = {
      ...ssrParams,
      ...urlParams,
    };
  }

  return urlParams;
};

export const getCriterias = listingFilters => {
  const queryParams = getAllUrlParams();
  const criterias = [];
  const themeVal = validateTheme({
    metaFilterList: listingFilters,
    themeValue: queryParams.themes,
  });
  queryParams.themes = themeVal;
  listingFilters?.forEach?.(filter => {
    const appliedFilterValue =
      queryParams[filter?.urlParam] || queryParams[`${filter?.urlParam}`.toLowerCase()];
    if (appliedFilterValue) {
      criterias.push({ id: filter.id, values: appliedFilterValue.split('~').filter(val => !!val) });
    }
  });
  return criterias;
};

export const getSortersCriterias = listingSorters => {
  const queryParams = getAllUrlParams();
  let appliedSorter = listingSorters?.[0];
  let appliedSorterValue = listingSorters?.[0]?.listingSorterValues?.[0];
  for (let i = 0; i < listingSorters?.length; i++) {
    const listingSorter = listingSorters[i];
    const appliedValue = queryParams[listingSorter.urlParam];
    if (appliedValue) {
      for (let j = 0; j < listingSorter?.listingSorterValues?.length; j++) {
        const listingFilterValue = listingSorter.listingSorterValues[j];
        if (appliedValue === listingFilterValue?.uniqueId) {
          appliedSorter = listingSorter;
          appliedSorterValue = listingFilterValue;
        }
      }
    }
  }

  const sorterCriterias = [{ id: appliedSorter?.id, values: [appliedSorterValue?.uniqueId] }];

  return sorterCriterias;
};

export const getFromCities = fromCities => {
  const formattedFromCities = [
    {
      title: 'TOP SEARCHES',
      cities: [],
    },
    {
      title: 'Cities',
      cities: [],
    },
  ];
  fromCities.forEach(city => {
    if (city.countryId !== 0) {
      if (city.topListed) {
        formattedFromCities[0].cities.push({
          name: city.name,
          country: city.countryName,
          data: city.airportCode,
          locusId: city.locusId,
        });
      } else {
        formattedFromCities[1].cities.push({
          name: city.name,
          country: city.countryName,
          data: city.airportCode,
          locusId: city.locusId,
        });
      }
    }
  });
  return formattedFromCities;
};

export const getAllAppliedFilters = (listingFilters, search) => {
  const urlParams = getAllUrlParams(search);
  const appliedFiltersArray = [];

  listingFilters.forEach(filter => {
    const appliedValue =
      urlParams[filter.urlParam] || urlParams[`${filter?.urlParam}`.toLowerCase()];
    if (appliedValue) {
      const valuesArray = appliedValue.split('~').filter(val => !!val);
      if (filter?.type === FILTER_TYPES.RANGE) {
        const { prefix = '', suffix = '' } = filter?.listingFilterValues?.[0] || {};
        valuesArray.forEach(value => {
          appliedFiltersArray.push({
            urlParam: filter.urlParam,
            optionData: {
              uniqueId: value,
              filterText: value
                .split('_')
                .map(val => `${prefix}${val}${suffix}`)
                .join(' - '),
            },
            currentFilterValue: valuesArray,
          });
        });
      } else {
        filter.listingFilterValues.forEach(listingOption => {
          if (
            valuesArray.indexOf(listingOption?.uniqueId) > -1 ||
            valuesArray.indexOf(listingOption?.uniqueId?.toLowerCase?.()) > -1
          ) {
            appliedFiltersArray.push({
              urlParam: filter.urlParam,
              optionData: listingOption,
              currentFilterValue: valuesArray,
            });
          }
        });
      }
    }
  });

  return appliedFiltersArray;
};

export const getCardLink = card => {
  const { dynamic, deeplink, filters, destination, redirectionPage, campaign } = card;
  const queryParamMap = getUrlParamsMapV2();
  let url = '';
  if (!dynamic) {
    return deeplink;
  }
  if (destination) {
    url = `dest=${destination}`;
  }
  if (campaign) {
    url = `campaign=${campaign}`;
  }
  if (queryParamMap?.depCity) {
    url += `&depCity=${queryParamMap.depCity}`;
  }
  const filterUrl = filters.reduce(
    (url = '', curr) => `${url}&${curr.urlParam}=${curr.values.join('_')}`,
    ''
  );
  if (filterUrl) {
    url = `${url}&${filterUrl}`;
  }
  if (redirectionPage === 'LISTING') {
    url = `${url}&redirectionPage=listing`;
  }

  url = `//${getHostName()}${LISTING_BASE_PATH}?${url}`;
  return encodeURI(url);
};

/**
 * Native scrollTo with callback
 * @param offset - offset to scroll to
 * @param callback - callback function
 */
export const scrollTo = (offset, callback) => {
  const fixedOffset = offset.toFixed();
  const onScroll = () => {
    if (window.scrollY.toFixed() === fixedOffset) {
      window.removeEventListener('scroll', onScroll);
      callback?.();
    }
  };

  window.addEventListener('scroll', onScroll);
  onScroll();
  window.scrollTo({
    top: offset,
    behavior: 'smooth',
  });
};

export const getAPWindow = date =>
  `AP_${Math.floor((new Date(date) - Date.now()) / (1000 * 60 * 60 * 24))}`;
